import produce from "immer"

import {
    STORAGE_AWS,
    FIRST_DAY_OF_MONTH,
    ONE_QUARTER,
    WEEKLY,
} from "const"
import { deepCopy, InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initAccountSettings: types.AccountSettings = {
    drive: {
        imageType: "",
        fileType: "",
        defaultStorage: STORAGE_AWS,
        googleDriveConnected: false,
        microsoftDriveConnected: false,
    },
    project: {
        defaultGroupsAssigned: false,
    },
    cc: {
        defaultLibraryAssigned: false,
        defaultResponsesAssigned: false,
        defaultRequirementsPriorityAssigned: false,
        defaultRequirementsReviewMethodAssigned: false,
        defaultRequirementsSmartComplianceAssigned: false,
        defaultRequirementsStatusAssigned: false,
        defaultRequirementsTypeAssigned: false,
        defaultReviewItemTypesAssigned: false,
    },
    lifecycle: {
        defaultLifecyclesAssigned: false,
    },
    sil: {
        defaultAssumption: "",
    },
    okr: {
        defaultMetricsAssigned: false,
        defaultSessionStartDate: FIRST_DAY_OF_MONTH,
        defaultSessionDuration: ONE_QUARTER,
        defaultSessionCadence: WEEKLY,
    },
    rrs: {
        defaultCategoriesAssigned: false,
        defaultTemplatesAssigned: false,
    },
    study: {
        studyFields: {
            description: true,
            manager: true,
            systemStage: true,
            studyStatus: true,
            location: true,
            site: true,
            plant: true,
            group: true,
            unit: true,
            subUnit: true,
        },
        teamMembersFields: {
            company: true,
            title: true,
            department: true,
            competence: true,
            phone: true,
            email: true,
            comments: true,
        },
        sessionFields: {
            facilitator: true,
            scribe: true,
            comment: true,
        },
    },
}

const initAccountSettingsState: types.AccountSettingsState = {
    settings: initAccountSettings,
}

const accountSettingsReducer = produce((
    draft: types.AccountSettingsState = initAccountSettingsState,
    action: ActionTypes = null,
): types.AccountSettingsState => {
    switch (action.type) {
        case types.SET_ACCOUNT_SETTINGS:
            draft.settings = action.settings
            return draft

        case types.UPDATE_ACCOUNT_SETTINGS: {
            const { section, settings } = action.data
            const newSettings = deepCopy(draft.settings)
            Object.keys(settings).forEach((settingId) => {
                if (newSettings[section]) {
                    newSettings[section][settingId] = settings[settingId]
                }
            })
            draft.settings = <types.AccountSettings>newSettings
            return draft
        }

        default:
            return draft
    }
})
export default accountSettingsReducer
